import React from "react";

import { VStack } from "@UI/Components/Stack/Stack";
import { Text } from "@UI/Components/Text/Text";
import {
  ICandidate,
  ICandidateCardProps,
  ICandidateTransparentPriceDetailsProps,
} from "../../types";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";
import { Rate } from "@Shared/Components/Rate/Rate";
import { Box } from "@UI/Components/Box/Box";

export const CandidateTransparentPriceDetails = (
  props: ICandidateTransparentPriceDetailsProps
) => {
  return (
    <>
      <Text
        as="h5"
        fontWeight="bold"
        fontSize={{ base: "1.125rem", md: "1.5rem" }}
        textDecoration="underline"
        m="0"
        cursor="pointer"
        onClick={props.onClick}
        data-stop-offcanvas // this attribute will help stop from triggering the profile modal from legacy code
        {...props.totalPriceStyle}
      >
        <Rate
          unit={props?.billingUnit}
          cents={props.totalPrice}
          currency={props?.rateCurrency}
          isShortFormat={props.isShortFormat}
        />
      </Text>
      {props?.billingUnit !== "flat" && props.totalExpense > 0 && (
        <Text
          fontSize={{ base: "0.875rem", md: "1rem" }}
          textDecoration="underline"
          m="0"
        >
          + <Rate cents={props.totalExpense} currency={props?.rateCurrency} />
        </Text>
      )}
    </>
  );
};

export const CandidateOfferSection = (
  props: ICandidate & Pick<ICandidateCardProps, "onCandidateOfferModalOpen">
) => {
  // const { currentUser } = useCurrentUser();

  // const totalExpense =
  //   props.serviceOffer?.expenses?.reduce(
  //     (total, expense) => total + expense?.amountCents,
  //     0
  //   ) + (!currentUser?.subscribed ? props.serviceOffer?.expensesFeesCents : 0);

  // let totalPrice =
  //   props?.serviceOffer?.rateCents +
  //   (!currentUser?.subscribed ? props?.serviceOffer?.serviceFeesCents : 0);

  // if (props?.serviceOffer?.billingUnit === "flat") totalPrice += totalExpense;

  if (props.serviceOffer?.rateType === "estimate") {
    return (
      <VStack
        spacing="0"
        data-stop-offcanvas
        onClick={() => {
          props.onCandidateOfferModalOpen(props.conversationId);
        }}
      >
        <Text fontSize="1.25rem" fontWeight="bold" color="gray.800" m="0">
          <FormattedMessage {...messages["serviceRequest.offerDetail.visit"]} />
        </Text>
        <Text fontSize="0.875rem">
          <FormattedMessage
            {...messages["serviceRequest.offerDetail.forQuote"]}
          />
        </Text>
      </VStack>
    );
  }

  return (
    <VStack
      spacing="0px"
      alignSelf={{
        base: "start",
        lg: !props?.serviceOffer ? "flex-start" : "center",
      }}
      alignItems="flex-end"
      textAlign="end"
    >
      {!props?.serviceOffer ? (
        <Text fontSize={{ base: "0.75rem", md: "0.875rem" }}>
          <FormattedMessage
            {...messages[
              props.offerWithdrawn || props.offerAsked
                ? props.offerWithdrawn
                  ? "serviceRequest.offerWithdrawn"
                  : "serviceRequest.offerAsked"
                : "serviceRequest.noOffer"
            ]}
          />
        </Text>
      ) : (
        <Box
          cursor="default"
          data-stop-offcanvas // this attribute will help stop from triggering the profile modal from legacy code
        >
          {/* <CandidateTransparentPriceDetails
            billingUnit={props?.serviceOffer?.billingUnit}
            totalPrice={totalPrice || 0}
            totalExpense={totalExpense || 0}
            rateCurrency={props?.serviceOffer?.rateCurrency}
            isSubscribed={currentUser?.subscribed}
            onClick={() => {
              props.onCandidateOfferModalOpen(props.conversationId);
            }}
          /> */}

          <Text
            as="h5"
            fontWeight="bold"
            fontSize={{ base: "1.125rem", md: "1.5rem" }}
            m="0"
          >
            <Rate
              unit={props?.serviceOffer?.billingUnit}
              cents={props?.serviceOffer?.rateCents}
              currency={props?.serviceOffer?.rateCurrency}
            />
          </Text>

          {props?.serviceOffer?.billingUnit && (
            <Text
              lineHeight="18px"
              fontSize={{ base: "0.75rem", md: "0.875rem" }}
            >
              <FormattedMessage
                {...messages[props?.serviceOffer?.billingUnit]}
              />
            </Text>
          )}

          {props?.serviceOffer?.offersFreeEstimation && (
            <Text
              as="h5"
              fontWeight="bold"
              fontSize={{ base: "0.75rem", md: "0.875rem" }}
            >
              <FormattedMessage
                {...messages["serviceRequest.offerDetail.freeVisit"]}
              />
            </Text>
          )}
        </Box>
      )}
    </VStack>
  );
};
